//let dragEntered = false;
let actualPointedCanvas = null;

export default {
    bind: (el, binding, vnode, oldVnode) => {
        let generateEvent = (eventName, target, e, x , y) => {

            const eventAwesome = new CustomEvent(eventName, {
              detail: {
                      clientX: x,
                      clientY: y
                    }
              });
              target.dispatchEvent(eventAwesome);
          };

        let getCanvasPointed = (e) => {
            let canvas = null;

            if (!e.touches || e.touches.length == 0)
                return null;

            var pointed = document.elementFromPoint(e.touches[0].screenX, e.touches[0].screenY);
            if (pointed && pointed.contentDocument) {
                let canvasEle = pointed.contentDocument.getElementById("rcanvas");
                if (canvasEle) {
                    let pointedRect = pointed.getBoundingClientRect();
                    let x = e.touches[0].pageX - pointedRect.x;
                    let y = e.touches[0].pageY - pointedRect.y;
                    canvas = {};
                    canvas.canvas = canvasEle;
                    canvas.x = x;
                    canvas.y = y;
                }

            }
            return canvas;
        };

        el.addEventListener('contextmenu', e => {
            e.preventDefault();
        });
        el.addEventListener('touchstart', e => {
            e.preventDefault();
            generateEvent("dragstart", e.currentTarget, e, 0, 0);
        });
        el.addEventListener('touchmove', e => {
            e.preventDefault();

            let canvasData = getCanvasPointed(e);
            if (canvasData) {
                if (actualPointedCanvas) {
                    actualPointedCanvas = canvasData;
                    generateEvent("dragover", canvasData.canvas, e, canvasData.x, canvasData.y);
                } else {
                    actualPointedCanvas = canvasData;
                    generateEvent("dragenter", canvasData.canvas, e, canvasData.x, canvasData.y);
                }
            } else {
                if (actualPointedCanvas) {
                    generateEvent("dragleave", actualPointedCanvas.canvas, e, 0, 0);
                    actualPointedCanvas = null;
                }
            }



        });
        el.addEventListener('touchend', e => {
            e.preventDefault();

            if (actualPointedCanvas) {
                generateEvent("drop", actualPointedCanvas.canvas, e, actualPointedCanvas.x, actualPointedCanvas.y);
            } else {
                //generateEvent("dragleave", actualPointedCanvas.canvas, e, 0, 0);
            }
            actualPointedCanvas = null;
        });
    }
};


// WEBPACK FOOTER //
// ./src/_eng/directives/mobile-drag.js